import React, { useState } from 'react';
import AutocompleteTextarea from './AutocompleteTextarea';

const TextareaStep = ({ question, value, onAnswer, onNext }) => {
  const [inputValue, setInputValue] = useState(value || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    onAnswer(inputValue);
    onNext();
  };

  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">
        {question.question}
      </h2>

      {/* Subtitle */}
      {question.subtitle && (
        <p className="text-center text-gray-500 mb-6">
          {question.subtitle}
        </p>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <AutocompleteTextarea
            question={question}
            value={inputValue}
            onChange={setInputValue}
            required={question.required || false}
          />
        </div>

        <button
          type="submit"
          className="btn-primary"
          data-testid="continue-button"
        >
          Continue
        </button>
      </form>
    </div>
  );
};

export default TextareaStep;
